export const CarouselDots = ({ articles, currentIndex, onDotClick }) => {
  if (articles.length <= 1) return null;

  return (
    <div className="flex justify-center mt-3 sm:mt-4 space-x-1.5 sm:space-x-2">
      {articles.map((article, index) => (
        <button
          key={article.id}
          onClick={() => onDotClick(index)}
          className={`h-2 rounded-full transition-all ${
            index === currentIndex ? 'bg-blue-600 w-5 sm:w-6' : 'bg-gray-300 w-2'
          }`}
          data-testid={`carousel-dot-${index}`}
          aria-label={`Go to article ${index + 1}`}
        />
      ))}
    </div>
  );
};
